<template>
	<div style="display: flex;height: 100vh;">
		<div style="width: 100%;display: flex;">
			<div style="height: 100%;">
				<img src="../assets/loginbg.png" style="height: 100%;">
			</div>
			<div style="flex-grow: 1;display: flex;background-color: white;">
				<div class="form-card-wrap" style="margin: auto;">
					<div
						:class="{ 'form-card': true, 'form-card-padding-50': true, 'form-card-padding-30': false }">
						 <div class="fnHeader">登录</div> 
						<div class="login-tabs">
							<!-- <div  style="background-color: white;" :class="{ 'tab-item': true, 'active': true }">微信登录
							</div> -->

						
							<!--activeIndex == 0 ? true : false-->
							<div @click="activeIndex = 0" :class="{ 'tab-item': true, 'active': activeIndex == 1 }">微信登录
							</div>
							<div @click="activeIndex = 1" :class="{ 'tab-item': true, 'active': activeIndex == 0 }">账号登录
							</div> 
							


							<div class="bg"    :style="{ left:  '100%'  }"></div> 
							<div class="bg" :style="{ left: activeIndex == 0 ? '0px' : 'calc(50% - 4px)' }"></div>
						</div> 
						<div class="dflex w100">
						 <div v-if="activeIndex == 1" class="dflex w100">

								<div class=" w100">
									<a-form ref="formRef" class="w100" :model="formState">
										<a-form-item name="telephone" has-feedback style="margin-bottom: 30px;"
											:rules="[{ required: true, message: '请输入手机号码！' }]">
											<a-input v-model:value="formState.telephone" placeholder="请输入手机号码"
												style="width: 100%;" />
										</a-form-item>

										<a-form-item has-feedback name="password"
											:rules="[{ required: true, message: '请输入密码！' }]">
											<a-input-password v-model:value="formState.password" placeholder="请输入密码" />
										</a-form-item>
									</a-form>
									<div>
										<a-button class="login-button w100" @click="toLoginT">
											登录
										</a-button>
									</div>
								</div>
							</div> 
							
						
							<div v-else   class="dflex w100 justcontent">
								<wxlogin v-if="wxloginVisible" appid="wx20711423128cb0c4" :scope="'snsapi_login'"
									:theme="'black'" :style="{ height: '300px' }"
									:redirect_uri='encodeURIComponent("http://qb.cbio.vip")'
									:href="'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6MTUwcHh9'"
									rel="external nofollow">
								</wxlogin>
								<div v-else style="text-align: center;">登陆中...</div>
							</div>

						</div>
					</div>
					<div style="text-align: center;margin-top: 40px;">情报强企 ©2022 Created by 强企信息</div>
				</div>
			</div>


		</div>

		<a-modal :visible="modalVisible" :footer="null" @cancel="toCancel">
			<div style="display: flex; align-items: center; justify-content: center;">
				<div style="    text-align: center;">
					<div style="    font-size: 16px; margin: 20px;">您的账号尚未注册，请联系客户经理</div>
					<div>
						<img style="width:120px" src="../assets/wechat.png" />
					</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>
<script setup>

import wxlogin from 'vue-wxlogin'
import { loginUser, getUnionid, loginUserM } from './js/index'
import { onMounted, reactive, ref } from 'vue';
import router from '@/router';
import store from '@/store';
import { message } from 'ant-design-vue/lib/components';
const activeIndex = ref(0)
const wxloginVisible = ref(true)
const modalVisible = ref(false)
const formState = reactive({
	telephone: '',
	password: ''
})
const formRef = ref(null)
onMounted(() => {
	var url = getUrl()
	if (url && url.code) {
		wxloginVisible.value = false
		toLogin(url.code)
	}
	else {
		wxloginVisible.value = true
	}
})
const getUrl = () => {
	var url = window.location.search
	var theRequest = new Object()
	if (url.indexOf("?") != -1) {
		var str = url.substr(1)
		var strs = str.split("&")
		for (var i = 0; i < strs.length; i++) {
			theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
		}
		return theRequest
	}
}
const toCancel = () => {
	var href = window.location.href
	if (href.indexOf('http://qb.cbio.vip:81') > -1) {
		window.location.href = 'http://qb.cbio.vip:81'
	}
	else {
		window.location.href = 'http://qb.cbio.vip'
	}
	router.replace({ name: 'loginPage' })
}
const toLogin = (val) => {
	getUnionid({
		code: val
	}).then((res) => {
		if (res.data) {
			loginUser({
				captch: "",
				loginName: "",
				password: '',
				"loginType": 4,
				"openid": res.data.openid,
				unionid: res.data.unionid
			}).then((res) => {
				if (res.data) {
					store.dispatch('token', res.data)
				} else {
					modalVisible.value = true
				}
			}
			)
		}
		else {
			modalVisible.value = true
		}
	})

}

const toLoginT = async () => {

	try {
		const values = await formRef.value.validateFields();
		loginUserM({
			captch: "",
			"loginName": values.telephone,
			"loginType": 2,
			"password": values.password,
		}).then((res) => {
			if (res.data) {
				store.dispatch('token', res.data)
			}
			else {
				message.error("手机号或密码填写错误，请检查！")
			}
		})

	} catch (errorInfo) {
		console.log('Failed:', errorInfo);
	}


}
</script>
<style lang="less" scoped>
@import "../assets/main.less";

.login-button {
	background-color: @primary-color;
	border: none;
	height: 42px;
	line-height: 30px;
	margin-top: 1.5rem !important;
	color: white;
}

.login-tabs .tab-item.active {
	color: @primary-color;
}
</style>

<style lang="css" scoped>
.justcontent {
	justify-content: center;
}


.dflex {
	display: flex;

}

.w100 {
	width: 100%;
}

.form-card-wrap {
	width: 440px;
	min-height: 500px;
}

.form-card-padding-30 {
	padding: 20px 20px;
}

.form-card-padding-50 {
	padding: 50px;
}

.form-card {
	width: 100%;
	margin-top: 32px;
	box-sizing: border-box;
	display: flex;

	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 32px;
	border-radius: 12px 0px 12px 12px;
	background: linear-gradient(to bottom, #f5f7fb, #fff);
	border: 2px solid #fff;
	box-shadow: 0px -2px 2px -2px rgba(102, 102, 102, 0.09), 0px 3px 6px 0px rgba(102, 102, 102, 0.09), 0px 5px 12px 4px rgba(102, 102, 102, 0.09);
}

.fnHeader {
	font-weight: bold;
	font-size: 26px;
}

.login-tabs {

	width: 100%;
	border-radius: 1.3125rem;
	height: 2.625rem;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	overflow: hidden;
	padding: 2px;
	position: relative;
	background: #f3f5f9;
	box-shadow: 0px 4px 4px 0px rgba(153, 153, 153, 0.1) inset, 4px 0px 4px 0px rgba(153, 153, 153, 0.1) inset;

}

.login-tabs .tab-item {
	z-index: 2;
	flex: 1;
	height: 100%;
	text-align: center;
	background-color: transparent;
	border-radius: 1.1875rem;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: color 0.3s;
}

.login-tabs .bg {
	position: absolute;
	top: 2px;
	left: 0;
	/* left: calc(50% - 4px); */
	width: 50%;
	height: 2.375rem;
	transform: translateX(2px);
	background-color: #fff;
	border-radius: 1.1875rem;
	overflow: hidden;
	transition: left 0.3s;
}
</style>